export default defineAppConfig({
  ui: {
    colors: {
      primary: 'brand',
      neutral: 'zinc'
    },
    pageSection: {
      slots: {
        container: 'py-8 sm:py-16 lg:py-24 gap-8 sm:gap-16',
        title: 'font-heading'
      }
    },
    pageCard: {
      slots: {
        title: 'font-heading'
      }
    },
    pageCTA: {
      slots: {
        title: 'font-heading'
      }
    },
    pageHero: {
      slots: {
        title: 'font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.15]'
      }
    },
    button: {
      slots: {
        base: [
          'rounded-xl rounded-tr-sm rounded-bl-sm'
        ]
      }
    },
    modal: {
      slots: {
        close: 'cursor-pointer'
      }
    },
    slideover: {
      slots: {
        close: 'cursor-pointer'
      }
    }
  }
})
